import { Pipe, PipeTransform, inject } from '@angular/core'
import { ICurrencyOptions } from '@core/models/currency.model'
import { CurrencyService } from '@core/services/currency.service'

@Pipe({
    name: 'localizedCurrency',
    standalone: true,
})
export class LocalizedCurrencyPipe implements PipeTransform {
    private currencyService = inject(CurrencyService)

    transform(
        value: number | string,
        currencyCode?: string,
        options?: Partial<ICurrencyOptions>,
    ): string {
        return this.currencyService.formatCurrency(value, currencyCode, options)
    }
}
